
import wx from 'weixin-js-sdk'
import { getConfig, addFile } from '@/api/wx.js'
import config from '@/config/index'
import { Field } from 'vant'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'

import { feedback } from '@/api/mall.js'
export default {
components: {
PopupPicker,
Group,
XTextarea,
[Field.name]: Field
},
name: 'complaint',
props: {},
data () {
return {
orderid: this.$route.params.orderid,
productid: this.$route.params.id,
baseUrl: config.baseUrl,
typelist: [
{ name: '发货问题（长期不发货/虚假发货等）', value: '1' },
{ name: '质量问题（实收商品与介绍不符等）', value: '2' },
{ name: '骚扰他人（频繁骚扰他人、辱骂/诅咒/威胁）', value: '3' },
{ name: '其他（以上情况以外类型）', value: '4' }],
type: [],
reason: '',
phone: '',
photoObj: {
imgcount: 9,
imglist: [],
fileUrlArr: []
},
height: document.body.scrollHeight,
showbutton: true
}
},
computed: {
accountid () {
return this.$store.state.user.accountid
}
},
watch: {
},
created () { },
mounted () {
this.wxconfig()
var h = document.body.scrollHeight
window.onresize = () => {
if (document.body.scrollHeight < h) {
this.showbutton = false
} else {
this.showbutton = true
}
}
},
methods: {
onblur (val, $event) {
window.scroll(0, 0)
document.activeElement.scrollIntoViewIfNeeded(true)
},

wxconfig () {
let ua = window.navigator.userAgent.toLowerCase()

let href = window.location.href.split('#')[0]
if (
ua.match(/MicroMessenger/i) == 'micromessenger' &&
ua.match(/wxwork/i) == 'wxwork'
) {
href = window.location.href.split('#')[0]

} else if (ua.match(/micromessenger/i) == 'micromessenger') {
href = this.$store.state.user.wechatSignUrl

}
console.log(href)
getConfig({
url: href
}).then(re => {
var configs = re.returnValue
wx.config({
debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
appId: configs.appId, // 必填，公众号的唯一标识
timestamp: configs.timestamp, // 必填，生成签名的时间戳
nonceStr: configs.nonceStr, // 必填，生成签名的随机串
signature: configs.signature, // 必填，签名，见附录1
jsApiList: ['chooseImage', 'uploadImage', 'previewImage'] 
})
})
},

chooseFile (imglist, imgcount) {
let count = imgcount - imglist.length
console.log('Touch')

var _this = this
wx.chooseImage({
count: count, // 默认9
sizeType: ['original', 'compressed'], // 可以指定是原图还是压缩图，默认二者都有
sourceType: ['album', 'camera'], // 可以指定来源是相册还是相机，默认二者都有
success: res => {
var localIds = res.localIds
_this.index = 0
if (localIds.length > 0) {
_this.uploadFile(imglist, localIds)
}
},
fail: res => {
console.log('失败')
},
complete: res => {
console.log('gg')
}
})
},

uploadFile (imglist, localIds) {
var _this = this
if (_this.index >= localIds.length) {
return
}
wx.uploadImage({
localId: localIds[_this.index], // 需要上传的图片的本地ID，由chooseFile接口获得
success: res => {
addFile({
mediaId: res.serverId
}).then(re => {
imglist.push(re.returnValue)
_this.photoObj.fileUrlArr.push(re.returnValue.filepath)
_this.index++
_this.uploadFile(imglist, localIds)
})
}
})
},

preview (index, fileList) {
let arr = fileList.map(item => this.baseUrl + item)
wx.previewImage({
current: arr[index], // 当前显示图片的http链接
urls: arr 
})
},
del (index) {
this.photoObj.imglist.splice(index, 1)
},
submit () {
if (this.type.length == 0) {
this.$vux.toast.text('请选择投诉类型', 'middle')
return false
}
if (this.reason.length == 0) {
this.$vux.toast.text('请填写投诉说明', 'middle')
return false
}
if (this.phone.length == 0) {
this.$vux.toast.text('请填写联系电话', 'middle')
return false
}
if (this.phone.length < 8) {
this.$vux.toast.text('请填写正确的联系电话', 'middle')
return false
}
let picids = this.photoObj.imglist.map(item => item.id)
picids = picids.join(';')
feedback({
type: this.type[0],
orderid: this.orderid,
productid: this.productid,
reason: this.reason,
paths: picids,
phone: this.phone,
accountid: this.accountid
}).then(res => {
if (res.success) {
let _this = this
this.$vux.alert.show({
content: '投诉成功',
onHide () {
_this.$router.go(-1)
}
})
}
})
}
}
}
